var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-style-container"},[_c('label',{staticClass:"properties-title"},[_vm._v("Style:")]),_c('Select',{attrs:{"items":_vm.options,"is-img-opts":"","selected-val":_vm.selectedBorderStyle},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }